var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-form" },
    [
      _c("h4", { staticClass: "mb-1" }, [
        _vm._v("\n        " + _vm._s(_vm.lang.title) + "\n    ")
      ]),
      _vm._v(" "),
      _vm.login_social.facebook
        ? _c("facebook-login-button", { on: { signedin: _vm.onLoginSuccess } })
        : _vm._e(),
      _vm._v(" "),
      _vm.login_social.google
        ? _c("google-login-button", { on: { signedin: _vm.onLoginSuccess } })
        : _vm._e(),
      _vm._v(" "),
      _vm.login_social.apple
        ? _c("apple-login-button", { on: { signedin: _vm.onLoginSuccess } })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "separator" }, [_vm._v(_vm._s(_vm.lang.or))]),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.login.apply(null, arguments)
            },
            keydown: function($event) {
              return _vm.form.errors.clear($event.target.name)
            }
          }
        },
        [
          _c("my-input", {
            attrs: {
              name: "email",
              type: "email",
              label: _vm.lang.placeholders.email
            },
            model: {
              value: _vm.form.email,
              callback: function($$v) {
                _vm.$set(_vm.form, "email", $$v)
              },
              expression: "form.email"
            }
          }),
          _vm._v(" "),
          _c("error-span", { attrs: { error: _vm.form.errors.get("email") } }),
          _vm._v(" "),
          _c("my-input", {
            attrs: {
              name: "password",
              type: "password",
              label: _vm.lang.placeholders.password
            },
            model: {
              value: _vm.form.password,
              callback: function($$v) {
                _vm.$set(_vm.form, "password", $$v)
              },
              expression: "form.password"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "password_recovery" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-text",
                    attrs: { href: _vm.lang.password_recovery_url }
                  },
                  [
                    _vm._v(
                      "                    \n                        " +
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm.lang.labels.password_recovery
                          )
                        ) +
                        "                  \n                    "
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _vm.$root.country == "it"
              ? _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "privacy_link" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-text",
                        attrs: { href: "/privacy/login.html" }
                      },
                      [
                        _vm._v(
                          "                    \n                        " +
                            _vm._s(
                              _vm._f("capitalize")(_vm.lang.labels.privacy)
                            ) +
                            "                  \n                    "
                        )
                      ]
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("error-span", {
            attrs: { error: _vm.form.errors.get("password") }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-network",
              attrs: { disabled: _vm.form.errors.any() }
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.lang.labels.login) + "\n        "
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }